import React from 'react';
import Icon from '@/components/ui/AppIcon';

type JobStatus = 'quoted' | 'accepted' | 'scheduled' | 'inprogress' | 'completed' | 'declined';

interface JobTimelineProps {
  status: JobStatus;
}

const timelineSteps = [
  { id: 'accepted', label: 'Quote Accepted', icon: 'DocumentCheckIcon' },
  { id: 'scheduled', label: 'Job Scheduled', icon: 'CalendarDaysIcon' },
  { id: 'inprogress', label: 'In Progress', icon: 'WrenchScrewdriverIcon' },
  { id: 'completed', label: 'Completed', icon: 'CheckCircleIcon' },
];

const statusOrder: Record<string, number> = {
  accepted: 0,
  scheduled: 1,
  inprogress: 2,
  completed: 3,
};

export default function JobTimeline({ status }: JobTimelineProps) {
  const currentOrder = statusOrder[status] ?? -1;

  return (
    <div className="flex items-start gap-0">
      {timelineSteps.map((step, idx) => {
        const stepOrder = statusOrder[step.id];
        const isDone = currentOrder > stepOrder;
        const isCurrent = currentOrder === stepOrder;
        const isPending = currentOrder < stepOrder;

        return (
          <React.Fragment key={`timeline-${step.id}`}>
            <div className="flex flex-col items-center gap-1.5 flex-shrink-0">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${
                  isDone
                    ? 'bg-primary text-primary-foreground'
                    : isCurrent
                    ? 'bg-primary text-primary-foreground ring-4 ring-primary/20'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                {isDone ? (
                  <Icon name="CheckIcon" size={14} variant="outline" />
                ) : (
                  <Icon name={step.icon as any} size={14} variant="outline" />
                )}
              </div>
              <span
                className={`text-xs font-medium text-center leading-tight max-w-[60px] ${
                  isCurrent ? 'text-primary' : isPending ? 'text-muted-foreground' : 'text-foreground'
                }`}
              >
                {step.label}
              </span>
            </div>
            {idx < timelineSteps.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-1 mt-4 transition-all ${
                  currentOrder > stepOrder ? 'bg-primary' : 'bg-border'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}